import { Component } from 'react';
import PropTypes from 'prop-types';

import getStructuredDataAttributes from '../lib/StructuredDataAttributes';

class JsonLdVideo extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    embedUrl: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    uploadDate: PropTypes.string.isRequired,
    duration: PropTypes.string,
    contentUrl: PropTypes.string,
    interactionCount: PropTypes.number
  };

  static defaultProps = {
    duration: '',
    contentUrl: '',
    interactionCount: ''
  };

  _generateJsonString = () => {
    const properties = getStructuredDataAttributes();

    return {
      '@context': 'https://schema.org/',
      '@type': 'VideoObject',
      name: this.props.name,
      description: this.props.description,
      thumbnailUrl: this.props.thumbnailUrl,
      uploadDate: this.props.uploadDate,
      ...(!!this.props.duration && { duration: this.props.duration }),
      ...(!!this.props.contentUrl && { contentUrl: this.props.contentUrl }),
      embedUrl: this.props.embedUrl,
      ...(!!this.props.interactionCount && {
        interactionCount: this.props.interactionCount
      }),

      publisher: {
        '@type': 'Organization',
        name: properties.name,
        image: '',
        logo: properties.logo,
        address: '',
        telephone: ''
      }
    };
  };

  render() {
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(this._generateJsonString())
        }}
      />
    );
  }
}

export default JsonLdVideo;
